export const shouldLoad = () => document.querySelector('.klt-site--standard--meinklett-table__action-menu') !== undefined;